import { SansText } from '../SansText/SansText'
import type { HorizontalCardDescriptionProps } from './HorizontalCardDescription.types'

export const HorizontalCardDescription = ({
  children,
}: HorizontalCardDescriptionProps): JSX.Element => {
  return <SansText as="span">{children}</SansText>
}
